import React, {useEffect} from 'react'
import useUrlChange from "./useUrlChange";

const useMount = func => useEffect(() => func(), []);

export {useMount, useUrlChange}
